import React, { useEffect, useState } from "react"; 
import useFilters from "../../../hooks/useFilters";
import FiltersContainer from "../../general/FiltersContainer";
import { postRequest, request } from "../../../utils/request";
import Loader from "../../general/Loader";
import Pagination from "../../general/Pagination";
import Modal from "../../general/Modal";
import Form from "./Form";
import { objectToFormData, toast } from "../../../utils/helpers";
import { apiUrl } from "../../../utils/apiUrl";
import { apiRequest } from "../../../hooks/apiRequest";

const Motivos = () => {
    const [motivos, setMotivos] = useState();
    const [motivo, setMotivo] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [errors, setErrors] = useState({});

    const { handleFilterChange, filtersQuery } = useFilters({buscar: null, tipo: null});

    const openCreate = () => {
        setMotivo({});

        setShowModal(true);
    };

    const openEdit = (item) => {
        setMotivo(item);

        setShowModal(true);
    };

    const closeModal = () => {
        setMotivo({});

        setShowModal(false);
    };

    const openDelete = (item) => {
        setMotivo(item);

        setShowDeleteModal(true);
    };

    const closeDelete = (item) => {
        setMotivo({});

        setShowDeleteModal(false);
    };

    const getMotivos = async (url) => {
        url = url ? url + "&limit=15" : `salud/motivos?limit=15`;

        setLoading(true);

        const response = await request(url);

        setMotivos(response);

        setLoading(false);
    };

    const generateUrl = () => {
        return `salud/motivos${filtersQuery}`;
    };

    const crearMotivo = async () => {
        const data = objectToFormData(motivo);

        const response = await postRequest(apiUrl("salud/motivos"), data);

        if (response.success) {
            getMotivos(generateUrl());

            closeModal();
        }

        if (response.code === 422) {
            setErrors(response.data.message);
        }
    };

    const EditarMotivo = async () => {
        const data = objectToFormData({...motivo, "_method": "put"});
        
        const response = await postRequest(apiUrl(`salud/motivos/${motivo.id}`), data);
        
        if (response.success) {
            getMotivos(generateUrl());

            closeModal();
        }

        if (response.code === 422) {
            setErrors(response.data.message);
        }
    };

    const onSave = async () => {
        setSaving(true);

        setErrors({});

        await (motivo.id ? EditarMotivo() : crearMotivo());
        
        setSaving(false);
    };

    const EliminarMotivo = async () => {
        setDeleting(true);
        
        const response = await apiRequest({}, `salud/motivos/${motivo.id}`, 'delete');
        
        if (response.success) {
            toast("Motivo Eliminado", "success");
            
            getMotivos(generateUrl());
            
            closeDelete();
        } else {
            toast(response.data.message, "error");
        }

        setDeleting(false);
    };

    useEffect(() => {
        getMotivos(generateUrl());
    }, [filtersQuery]);

    return <>
        <FiltersContainer>
            <div className='col'>
                <label htmlFor='search'>Buscar</label>
                <input
                    name='buscar'
                    onChange={(e) => handleFilterChange("buscar", e?.target.value)}
                    type='search'
                    placeholder='Buscar...'
                    className='form-control'
                />
            </div>

            <div className='col-3'>
                <label htmlFor='estado'>Tipo de Visita</label>
                <select
                    name="tipo"
                    className="form-control"
                    placeholder="Seleccionar..."
                    onChange={e => handleFilterChange('tipo', e.target.value)}
                >
                    <option value="">Todas</option>
                    <option value="Médica">Médica</option>
                    <option value="Psicología">Psicología</option>
                </select>
            </div>

            <div className="col-3" style={{height: "100%"}}>
                <div className="row" style={{height: "100%"}}>
                    <button className="au-btn au-btn-icon au-btn--green au-btn--small mt-auto ml-auto" onClick={openCreate}>+ Nuevo Motivo</button>
                </div>
            </div>
        </FiltersContainer>

        {loading && <Loader />}
        {!loading && motivos?.data.length && <div className="table-data">
             <table className='table table-data2'>
                <thead>
                    <tr>
                        <th>Descripción</th>
                        <th>Tipo</th>
                        <th className='text-right'></th>
                    </tr>
                </thead>

                <tbody>
                    {motivos?.data.map(motivo => <tr key={motivo.id} className="tr-shadow">
                        <td>{motivo.descripcion}</td>
                        <td>{motivo.tipo}</td>
                        <td>
                            <div className="table-data-feature">
                                <button
                                    className="item"
                                    onClick={() => openEdit(motivo)}
                                >
                                    <i className="zmdi zmdi-edit" />
                                </button>

                                <button
                                    className="item"
                                    onClick={() => openDelete(motivo)}
                                >
                                    <i className="zmdi zmdi-delete" />
                                </button>
                            </div>
                        </td>
                    </tr>)}
                </tbody>
            </table>

            {motivos?.links && (<Pagination links={motivos.links} meta={motivos.meta} getData={getMotivos} />)}
        </div>}

        {!loading && motivos?.data.length === 0 && <div className='text-center p-t-20 p-b-40'>
            { filtersQuery !== '?' ? "No hay elementos que coincidan con la búsqueda." : "No hay elementos creados." }
        </div>}

        <Modal
            show={showModal}
            blank={true}
            toggle={closeModal}>
            <Form
                motivo={motivo}
                setMotivo={setMotivo}
                cancel={closeModal}
                onSave={onSave}
                saving={saving}
                errors={errors}
            />
        </Modal>

        <Modal
            title={`Eliminar Motivo`}
            show={showDeleteModal}
            blank={false}
            callback={EliminarMotivo}
            toggle={closeDelete}>
                {
                    deleting
                    ? <><Loader /></> 
                    : <p className="px-3 pb-3">
                        ¿Estás seguro que desea eliminar el motivo <strong>"{motivo.descripcion}"</strong> de tipo: <strong>{motivo.tipo}</strong>? 
                        (Esta acción no se puede deshacer).
                    </p>
                }
        </Modal>
    </>;
};

export default Motivos;